import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Send } from 'lucide-react';
export function PublicFormPage() {
  const {
    formSlug
  } = useParams();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      navigate('/inquiry/thanks');
    }, 1000);
  };
  return <div className="min-h-screen bg-background text-textMain py-12 px-6" data-id="element-6909">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-2xl mx-auto" data-id="element-6910">
        <div className="text-center mb-8" data-id="element-6911">
          <div className="w-16 h-16 rounded-xl bg-primary/20 flex items-center justify-center text-primary text-2xl font-bold mx-auto mb-4" data-id="element-6912">
            EB
          </div>
          <h1 className="text-3xl font-bold mb-2" data-id="element-6913">Booking Inquiry</h1>
          <p className="text-textMuted" data-id="element-6914">The Empty Bottle • Chicago, IL</p>
        </div>

        <div className="bg-surface border border-border rounded-2xl p-6 md:p-8" data-id="element-6915">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-6916">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6917">
              <div data-id="element-6918">
                <label className="block text-sm font-medium mb-2" data-id="element-6919">
                  Artist / Band Name *
                </label>
                <input required type="text" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6920" />
              </div>
              <div data-id="element-6921">
                <label className="block text-sm font-medium mb-2" data-id="element-6922">
                  Contact Name *
                </label>
                <input required type="text" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6923" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6924">
              <div data-id="element-6925">
                <label className="block text-sm font-medium mb-2" data-id="element-6926">
                  Email Address *
                </label>
                <input required type="email" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6927" />
              </div>
              <div data-id="element-6928">
                <label className="block text-sm font-medium mb-2" data-id="element-6929">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6930" />
              </div>
            </div>

            <div data-id="element-6931">
              <label className="block text-sm font-medium mb-2" data-id="element-6932">
                Requested Date(s) *
              </label>
              <input required type="text" placeholder="e.g., June 12th or mid-June" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6933" />
            </div>

            <div data-id="element-6934">
              <label className="block text-sm font-medium mb-2" data-id="element-6935">
                Links (Spotify, Website, Live Video) *
              </label>
              <textarea required rows={3} className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-6936"></textarea>
            </div>

            <div data-id="element-6937">
              <label className="block text-sm font-medium mb-2" data-id="element-6938">
                Additional Notes / Expected Draw
              </label>
              <textarea rows={4} className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-6939"></textarea>
            </div>

            <div className="pt-4 border-t border-border" data-id="element-6940">
              <button type="submit" disabled={isSubmitting} className="w-full py-3 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2 disabled:opacity-70" data-id="element-6941">
                {isSubmitting ? 'Submitting...' : <>
                    <Send className="w-4 h-4" data-id="element-6942" /> Submit Inquiry
                  </>}
              </button>
              <p className="text-center text-xs text-textMuted mt-4" data-id="element-6943">
                Powered by{' '}
                <Link to="/" className="text-primary hover:underline" data-id="element-6944">
                  Booker
                </Link>
              </p>
            </div>
          </form>
        </div>
      </motion.div>
    </div>;
}